import { BuildingOpeningDay } from './building-opening-day.model';
import { Organization } from '../member/legal-entity.model';
import { Media } from '../media.model';
import { CancellationParamModel } from '../CancellationParam.model';

export class Building {
  currency: string;
  id?: string;
  image: string;
  manager?: Organization | string;
  name?: string;
  openingDays?: BuildingOpeningDay[] | string[];
  picture?: Media | string;
  timeZone: string;
  public cancellationParam: CancellationParamModel[];

  constructor(values= {}) {
    Object.assign(this, values);

    if (values.hasOwnProperty('openingDays')) {
      this.openingDays = new Array<BuildingOpeningDay>();
      for (const day of values['openingDays']) {
        this.openingDays.push(new BuildingOpeningDay(day));
      }
    }
  }

  getOpeningDay(number: number): BuildingOpeningDay {
    const days = this.openingDays as Array<BuildingOpeningDay>;

    for (const day of days) {
      if (day.day === number) {
        return day;
      }
    }

    return days[0];
  }

  toString() {
    return this.name;
  }
}
